import getYouTubeId from 'get-youtube-id'
import React from 'react'

const YouTubeEmbed = ({ url }) => {
  const id = getYouTubeId(url)
  return (
    <iframe
      width='100%'
      loading='lazy'
      height='350'
      src={`https://www.youtube.com/embed/${id}`}
      srcDoc={`<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/${id}?autoplay=1><img loading="lazy" src=https://img.youtube.com/vi/${id}/hqdefault.jpg><span>▶</span></a>`}
      frameBorder='0'
      allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
      allowFullScreen
    />
  )
}

export default YouTubeEmbed
